import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
} from "@/services/api";
import {
  EmailTypeRole,
  ReadEmailType,
  UpdateEmailTypeRolesPayload,
} from "@/types/emailType";

const EmailTypeServiceAPI = new APIService(API.Emails);

export const EmailTypeService = {
  getTypes: (fetchParams?: FetchListRequest<ReadEmailType>) =>
    EmailTypeServiceAPI.getList<SuccessFetchListResponse<ReadEmailType>>(
      fetchParams,
      "/types",
    ),
  getType: (emailTypeId: string) =>
    EmailTypeServiceAPI.get<ReadEmailType>(`types/${emailTypeId}`),
  updateType: (emailTypeId: string, payload: { description: string | null }) =>
    EmailTypeServiceAPI.patch(`types/${emailTypeId}`, payload),
  getAvailableRoles: (
    emailTypeId: string,
    fetchParams?: FetchListRequest<EmailTypeRole>,
  ) =>
    EmailTypeServiceAPI.getList<SuccessFetchListResponse<EmailTypeRole>>(
      fetchParams,
      `/types/${emailTypeId}/roles/available`,
    ),
  updateRoles: (emailTypeId: string, payload: UpdateEmailTypeRolesPayload) =>
    EmailTypeServiceAPI.patch(`types/${emailTypeId}/roles`, payload),
};
